
  import { defineComponent, ref } from 'vue';
  import { updatePassword } from '@/services/api/resources/user';
  import { IdProps, toasted } from '@/ui/helpers';
  import { Box } from '@/ui/components/Box';
  import { PageSubtitle } from '@/ui/components/PageSubtitle';
  import { InputField } from '@/ui/components/form';
  import { useTask, useValidation } from '@/ui/concerns';
  import { validate as validatePassword } from '@/entities/auth/passwordChangingUser';
  import { t } from '@/ui/i18n/i18n';
  import { ApiErrorMessage } from '@/ui/components/message/ApiErrorMessage';
  import { Button } from '@/ui/components/Button';
  import { CLICK_EVENTS, trackClick } from '@/services/activityTracker/activityTrackerHelper';

  export default defineComponent<IdProps>({
    name: 'UserEditPasswordTab',
    components: { Box, PageSubtitle, InputField, ApiErrorMessage, Button },
    props: ['id'],
    setup(props) {
      const passwords = ref({ password: '', confirm: '' });

      const {
        run: updatePasswordTask,
        state: updatePasswordState,
      } = useTask(
        () => updatePassword(props.id, passwords.value.password),
        () => toasted.success(t('profile.password-updated')),
      );

      const {
        validationErrors: passwordValidationErrors,
        hasNoValidationErrors: passwordHasNoValidationErrors,
        showValidationErrors: passwordShowValidationErrors,
      } = useValidation(validatePassword, passwords, updatePasswordState);

      const inputPassword = (value: string) => {
        passwords.value.password = value;
      };

      const inputPasswordConfirm = (value: string) => {
        passwords.value.confirm = value;
      };

      const handlePasswordUpdate = () => {
        passwordShowValidationErrors.value = true;
        if (passwordHasNoValidationErrors.value) {
          trackClick(CLICK_EVENTS.CHANGE_PASSWORD);
          updatePasswordTask();
        }
      };

      return {
        passwords,
        updatePasswordState,
        passwordValidationErrors,
        passwordHasNoValidationErrors,
        passwordShowValidationErrors,
        inputPassword,
        inputPasswordConfirm,
        handlePasswordUpdate,
      };
    },
  });
